import { FC } from 'react'
import { Menu } from '@mui/icons-material'
import { SvgIconProps } from '@mui/material/SvgIcon'

export const MenuIcon: FC<SvgIconProps> = (props: SvgIconProps) => {
  return <Menu {...props} />
}
